import { IDocumentosPdf } from '../entities/IDocumentosPdf'
import { ILoteSolicitadoRepository } from '../repositories/ILoteSolicitadoRepository'

export interface IGetAllDocumentosPdf {
  execute(tmovLoteConjuntoId: number): Promise<IDocumentosPdf>
}

export default class IGetAllDocumentosPdfImpl implements IGetAllDocumentosPdf {
  constructor(
    private readonly loteSolicitadoRepository: ILoteSolicitadoRepository,
  ) {}

  public async execute(tmovLoteConjuntoId: number): Promise<IDocumentosPdf> {
    return this.loteSolicitadoRepository.getAllDocumentosPdf(tmovLoteConjuntoId)
  }
}
